import React from 'react';
import createReactClass from 'create-react-class';

import axios from '@/util/axios';
import { getMenuItems } from '@/exceed';
import { handleAxiosError } from 'core/notifications';
import { withContainer } from 'core/cache';

import addRemoveTagModal from '../helpers/addRemoveTagModal';
import addTagContentModal from '../helpers/addTagContentModal';
import addTopicTagMappingModal from '../helpers/addTopicTagMappingModal';
import { getInitiativeUsage } from '../helpers/getMockData';

import InitiativeUsage from '../components/initiativeUsage';

// const initialQuery = { sort: 'alphabetical' };
const initialQuery = { locale: null };

const InitiativeUsageContainer = createReactClass({
  getInitialState() {
    return { hasHelp: !window.hasClosedUsageMessage, selection: [] };
  },

  componentWillUnmount() {
    this.resetQuery();
  },

  async handleBulkTagButtonClick() {
    const { initiative, topicSelection } = this.props;
    const { payload, type } = await addTopicTagMappingModal(topicSelection.data);

    if (type !== 'save') return;

    const initiativeId = initiative.data.id;

    topicSelection.setStatus('syncing');

    try {
      await axios.put(`/api/admin/initiatives/${initiativeId}/update_tagged_topics`, {
        data: { topic_ids: payload.topics.map(({ id }) => id) },
      });
    } catch (error) {
      handleAxiosError(error);
    }

    this.fetchCaches();
  },

  handleClearButtonClick() {
    this.resetQuery();
    this.props.usage.fetch();
  },

  async handleCloseButtonClick() {
    this.setState({ hasHelp: false });

    try {
      await axios.put('/initiatives/has_closed_usage_message');
    } catch (error) {
      handleAxiosError(error);
    }
  },

  handleFilterChange({ isSelected, key, value }) {
    const { usage } = this.props;

    usage.setQuery({ [key]: isSelected ? value : null }, { setType: 'extend' });
    usage.fetch();
  },

  async handleRemoveButtonClick() {
    const action = await addRemoveTagModal();

    if (action.type !== 'remove') return;

    const initiativeId = this.props.initiative.data.id;
    const contents = this.state.selection.map(({ id, type }) => ({ id, type }));

    try {
      await axios.delete(`/api/admin/initiatives/${initiativeId}/bulk_untag_content`, {
        data: { data: { contents } },
      });
    } catch (error) {
      return handleAxiosError(error);
    }

    this.fetchCaches();
    this.setState(this.getInitialState());
  },

  async handleTagButtonClick() {
    const action = await addTagContentModal();

    if (action.type !== 'save') return;

    const initiativeId = this.props.initiative.data.id;
    const { id, type } = action.payload.content;

    this.props.topicSelection.setStatus('syncing');

    try {
      await axios.post(`/api/admin/initiatives/${initiativeId}/tag_content`, {
        data: { content_id: id, content_type: type },
      });
    } catch (error) {
      handleAxiosError(error);
    }

    this.fetchCaches();
  },

  handleToggleAll(isChecked) {
    this.setState({ selection: isChecked ? this.props.usage.data : [] });
  },

  handleUsageSelectionChange(isChecked, item) {
    const itemId = item.id;

    this.setState(({ selection }) => ({
      selection: isChecked
        ? [...selection, item]
        : selection.filter(({ id }) => id !== itemId),
    }));
  },

  getAddMenuItems() {
    return getMenuItems([
      {
        icon: 'tagOutline',
        key: 'tag-content',
        onClick: this.handleTagButtonClick,
      },
      {
        icon: 'folderOutline',
        isDisabled: this.props.topicSelection.status !== 'success',
        key: 'bulk-tag-content',
        onClick: this.handleBulkTagButtonClick,
      },
    ]);
  },

  fetchCaches() {
    const { topicSelection, usage } = this.props;

    topicSelection.fetch();
    usage.fetch();
  },

  resetQuery() {
    this.props.usage.setQuery(initialQuery);
  },

  render() {
    const { hasHelp, selection } = this.state;
    const { usage: { data, query, status } } = this.props;

    return (
      <InitiativeUsage
        addMenuItems={this.getAddMenuItems()}
        hasHelp={hasHelp}
        filterSelection={query}
        isLoading={status !== 'success'}
        onClearButtonClick={this.handleClearButtonClick}
        onCloseButtonClick={this.handleCloseButtonClick}
        onFilterChange={this.handleFilterChange}
        onRemoveButtonClick={this.handleRemoveButtonClick}
        onToggleAll={this.handleToggleAll}
        onUsageSelectionChange={this.handleUsageSelectionChange}
        usage={data}
        usageSelection={selection}
      />
    );
  },
});

export default withContainer(InitiativeUsageContainer, {
  cache: {
    initiative: { isListener: true },
    topicSelection: { isListener: true },
    usage: {
      getMockedResponse: () => ({ data: getInitiativeUsage() }),
      getParams: ({ props }) => ({ id: props.initiative.data.id }),
      initialData: [],
      isMocked: false,
      query: initialQuery,
      transform: ({ data }) => data.data,
      url: '/api/admin/initiatives/:id/tagged_content',
    },
  },
});
